import { render, staticRenderFns } from "./QualificationPrize2020.vue?vue&type=template&id=a1f960b2&"
import script from "./QualificationPrize2020.vue?vue&type=script&lang=js&"
export * from "./QualificationPrize2020.vue?vue&type=script&lang=js&"
import style0 from "./QualificationPrize2020.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports